
import {filter} from 'rxjs/operators';
import { Injectable, PLATFORM_ID, Inject, Injector } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { isPlatformBrowser } from '@angular/common';
import { UserModel } from '../models/user.model';
import { Router, ResolveEnd, ActivatedRouteSnapshot } from '@angular/router';

export interface IError {
    message: string;
    response?: any;
}
@Injectable()
export class AppInsightClientService {
    isBrowser: boolean;
    user: UserModel;
    userId: string;
    appInsights: ApplicationInsights;

    constructor(
        private router: Router,
        @Inject(PLATFORM_ID) private platformId) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    init(iKey: string, user: UserModel) {
        if (!this.isBrowser)
            return;
          this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: iKey,
                enableAutoRouteTracking: true,
                // extensions: [this.angularPlugin],
                // extensionConfig: {
                //     [this.angularPlugin.identifier]: { router: this.router }
                // }
            }
        });

        
        this.userId = `${user.email} [${user.role}] (${user.companyName})`;
        this.user = user;
        this.appInsights.loadAppInsights();
        this.appInsights.setAuthenticatedUserContext(this.userId);

        this.router.events.pipe(
            filter(event => event instanceof ResolveEnd))
            .subscribe((event: ResolveEnd) => {
                const activatedComponent = this.getActivatedComponent(event.state.root);
                if (activatedComponent) {
                    this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
                }
            });
    }

    public logPageView(
        name: string,
        url?: string,
        properties?: { [key: string]: string },
        measurements?: { [key: string]: number },
        duration?: number) {
         if (!this.isBrowser) {
            return;
        }
        this.appInsights.trackPageView({
            name,
            uri: url,
            properties: this.appendUserInfo(properties),
            measurements
        });
    }

    public logEvent(name: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
          if (!this.isBrowser) {
            return;
        }
        this.appInsights.trackEvent({ 
            name, 
            properties: this.appendUserInfo(properties),
            measurements 
        });
    }

    public logError(error: Error, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
          if (!this.isBrowser) {
            return;
        }
        this.appInsights.trackException({
            exception: error,
            properties: this.addGlobalProperties(properties),
            measurements
        });
    }

    private appendUserInfo(properties: { [key: string]: string }) {
        if (!properties) {
            properties = {};
        }
        properties.userRole = this.user.role;
        properties.userEmail = this.user.email;
        properties.companyId = this.user.companyId;
        properties.companyName = this.user.companyName;
        return properties;
    }

    private addGlobalProperties(properties?: { [key: string]: string }): { [key: string]: string } {
        if (!properties) {
            properties = {};
        }
        return properties;
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {

        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = '';
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }

        return path;
    }
}
